import request from '../utils/request';

export function getStatsApi() { return request.get('/home/stats'); }
export function getThemeStylesApi() { return request.get('/home/themeStyles'); }
export function getThemeBindAppsApi(themeCode) { return request.get('/home/themeBindApps', { params: { themeCode } }); }
export function getMyAppsApi() { return request.get('/home/myApps'); }
export function updateKeyApi(data) { return request.post('/home/updateKey', data); }
export function removeAppApi(data) { return request.post('/home/removeApp', data); }
export function updateProtectionApi(data) { return request.post('/home/updateProtection', data); }
export function updateThemeApi(data) { return request.post('/home/updateTheme', data); }
export function updateThemeSettingApi(data) { return request.post('/home/updateThemeSetting', data); }
export function getUserConfigApi() { return request.get('/home/userConfig'); }
export function getThemeWindowConfigApi(themeCode) { return request.get('/home/themeWindowConfig', { params: { themeCode } }); }
export function saveThemeWindowConfigApi(data) { return request.post('/home/saveThemeWindowConfig', data, { headers: { 'Content-Type': 'multipart/form-data' } }); }
export function getThemeAppsApi(themeCode) { return request.get('/home/themeApps', { params: { themeCode } }); }
export function saveThemeAppsApi(data) { return request.post('/home/themeApps', data); }
export function getThemeDesktopIconsApi(themeCode) { return request.get('/home/themeDesktopIcons', { params: { themeCode } }); }
export function saveThemeDesktopIconsApi(data) { return request.post('/home/saveThemeDesktopIcons', data); }
export function getClientDownloadApi() { return request.get('/home/clientDownload'); }
export function getAvailableAppsApi(params) { return request.get('/home/availableApps', { params }); }

// 用户自定义应用
export function getCustomAppsApi(params) { return request.get('/apps/list', { params }); }
export function addCustomAppApi(fd) { return request.post('/apps', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); }
export function updateCustomAppApi(id, fd) { return request.put(`/apps/${id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }); }
export function toggleCustomAppApi(id) { return request.put(`/apps/${id}/toggle`); }
export function deleteCustomAppApi(id) { return request.delete(`/apps/${id}`); }

// 开机启动项
export function getStartupApi() { return request.get('/home/startup'); }
export function saveStartupApi(fd) { return request.post('/home/startup', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); }
export function deleteStartupApi() { return request.delete('/home/startup'); }

// 新版：用户应用配置（与主题无关）
export function getUserEnabledAppsApi() { return request.get('/home/userEnabledApps'); }
export function saveUserEnabledAppsApi(data) { return request.post('/home/saveUserEnabledApps', data); }
export function getUserDesktopIconsApi() { return request.get('/home/userDesktopIcons'); }
export function saveUserDesktopIconsApi(data) { return request.post('/home/saveUserDesktopIcons', data); }
